export enum FontSize {
  ExtraSmall = "8px",
  Small = "12px",
  Medium = "14px",
  Large = "18px",
  ExtraLarge = "24px",
}
